import { render, staticRenderFns } from "./WallpaperSearch.vue?vue&type=template&id=63b57591&scoped=true"
import script from "./WallpaperSearch.vue?vue&type=script&lang=js"
export * from "./WallpaperSearch.vue?vue&type=script&lang=js"
import style0 from "./WallpaperSearch.vue?vue&type=style&index=0&id=63b57591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b57591",
  null
  
)

export default component.exports